export default "__VITE_ASSET__D1_LGAc$__"